"use client";

import Link from "next/link";
import React from "react";
import { FaCheckCircle } from "react-icons/fa";
import Container from "../Container";
import Image from "next/image";

const Demo = () => {
    return (
        <section id="demo" className="py-20 text-black ">
            <Container>
                <div className="mx-auto px-4 sm:px-6 lg:px-8">
                    <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
                        Automate boring tasks like SEO
                    </h2>
                    <div className="mb-12 flex flex-col md:flex-row items-start gap-6 md:gap-8 max-w-3xl mx-auto">
                        <div className="flex-shrink-0">
                            <Image
                                src="/images/eliana-photo.jpeg"
                                alt="Eliana"
                                width={100}
                                height={100}
                                className="w-24 h-24 rounded-full object-cover border-2 border-gray-300 shadow-md"
                            />
                        </div>
                        <div className="text-left">
                            <p className="text-sm mb-3 leading-relaxed">
                                <strong>Hey! I'm Eliana</strong>, a dive instructor turned coder who builds apps 🚀. I created three SaaS products —
                                <a href="https://scubareputation.com" target="_blank" rel="noopener noreferrer" className="text-emerald-500 underline">ScubaReputation</a>,&nbsp;
                                <a href="https://peerquik.com" target="_blank" rel="noopener noreferrer" className="text-emerald-500 underline">Peerquik</a> and
                                <a href="https://beunderwater.com" target="_blank" rel="noopener noreferrer" className="text-emerald-500 underline ml-1">BeUnderwater</a> — but got tired of expensive SEO tools and endless keyword research.
                            </p>
                            <p className="text-sm leading-relaxed">
                                So I built <strong>SEOZast</strong> to make SEO affordable for everyone. Analyse, find keywords, generate AI articles, and deploy to GitHub or download — all for just €5/month.
                            </p>
                        </div>
                    </div>

                    <div className="mb-12">
                        <div className="relative w-full max-w-lg mx-auto aspect-[16/9]">
                            <iframe
                                className="w-full h-full rounded-lg"
                                src="https://www.youtube.com/embed/-GngvyA8AtA" // Replace VIDEO_ID with your actual YouTube video ID
                                title="your app Demo Video"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                        <p className="text-md mt-8 text-center text-gray-400 font-medium italic">
                            <span className="text-emerald-400 text-xl">"</span>Made for startups tired of overpriced SEO tools<span className="text-emerald-400 text-xl">"</span>.
                        </p>
                    </div>
                </div>
            </Container>
        </section>
    );
};

export default Demo;